import { CellContext } from '@tanstack/react-table';
import React from 'react';
import { OccasionsEnum } from '../../types/bundles.types';

const Inner = ({ occasions, showIcon = true }: { occasions: OccasionsEnum[]; showIcon?: boolean }) => {
  const arrayElements: React.ReactNode[] = [];

  if (!occasions || occasions?.length === 4 || occasions?.length === 0) {
    arrayElements.push(<div>All</div>);
    return <>{arrayElements.map((el) => el)}</>;
  }

  occasions.forEach((occasion: OccasionsEnum) => {
    switch (occasion) {
      case OccasionsEnum.CARRYOUT:
        arrayElements.push(<div>Carryout</div>);
        break;
      case OccasionsEnum.DELIVERY:
        arrayElements.push(<div>Delivery</div>);
        break;
      case OccasionsEnum.DINE_IN:
        arrayElements.push(<div>Dine-In</div>);
        break;
      case OccasionsEnum.DRIVE_THRU:
        arrayElements.push(<div>Drive Thru</div>);
        break;
      default:
    }
  });
  return <>{arrayElements.map((eleme) => eleme)}</>;
};

export const DisplayOccasionWithoutIcon = <TData extends { occasions: OccasionsEnum[] }>({
  row,
}: CellContext<TData, unknown>) => <Inner occasions={row.original.occasions} showIcon={false} />;

export const DisplayOccasionWithIcon = <TData extends { occasions: OccasionsEnum[] }>({
  row,
}: CellContext<TData, unknown>) => <Inner occasions={row.original.occasions} />;
